export default __webpack_public_path__ + "static/media/hakuba_ogImage_1200.3b6cfb0c.jpg";